import { useMutation } from "urql";

import { UpdateLimitRequestPaymasterDocument } from "../../../../graphql/generated.ts";

export function useUpdateLimitRequestPaymaster() {
  return useMutation(UpdateLimitRequestPaymasterDocument);
}
